var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17008 -1.464e-06C1.31948 -0.000509759 1.46709 0.0324626 1.60207 0.0964913C1.73704 0.16052 1.85596 0.253979 1.95008 0.369999L6.78008 6.37C6.92716 6.54893 7.00757 6.77337 7.00757 7.005C7.00757 7.23662 6.92716 7.46107 6.78008 7.64L1.78008 13.64C1.61034 13.8442 1.36643 13.9726 1.102 13.997C0.837577 14.0214 0.574296 13.9397 0.37008 13.77C0.165863 13.6003 0.0374389 13.3563 0.0130592 13.0919C-0.0113205 12.8275 0.0703412 12.5642 0.24008 12.36L4.71008 7L0.390081 1.64C0.267798 1.49321 0.190121 1.31447 0.166241 1.12492C0.142362 0.935376 0.173279 0.742951 0.255335 0.570423C0.337391 0.397896 0.46715 0.252485 0.629261 0.151394C0.791371 0.0503039 0.979047 -0.00223308 1.17008 -1.464e-06Z",
    fill: "#D6D6D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.193a2fa1.svg";
export { ForwardRef as ReactComponent };